import routesHRM from "./routesHrm";
import routesACCOUNTING from "./routesAccounting";
import routesLOGISTICS from "./routesLogistic";
import routesBUYS from "./routesBuys";
import routesDISPATCHES from "./routesDispatches";
//import routesSales from "./routesSales"
import { ModulesError } from "../modules";
import { LayoutsError } from "../layouts";
import { CustomLayout } from "../components/layouts";
import { PageHome } from "../modules";

const TestComponent = () => {
    return (
        <div className="p-8 max-w-2xl mx-auto">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-6 mb-6">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                    🎉 ¡Tailwind CSS está funcionando!
                </h1>
                <p className="text-gray-600 dark:text-gray-300 mb-6">
                    ¡Felicidades! Ya tienes Tailwind CSS configurado en tu
                    proyecto.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div className="bg-blue-100 dark:bg-blue-900/30 p-4 rounded-lg">
                        <div className="text-2xl font-bold text-blue-700 dark:text-blue-300">
                            1
                        </div>
                        <div className="text-sm text-blue-600 dark:text-blue-400">
                            Instalado
                        </div>
                    </div>
                    <div className="bg-green-100 dark:bg-green-900/30 p-4 rounded-lg">
                        <div className="text-2xl font-bold text-green-700 dark:text-green-300">
                            2
                        </div>
                        <div className="text-sm text-green-600 dark:text-green-400">
                            Configurado
                        </div>
                    </div>
                    <div className="bg-purple-100 dark:bg-purple-900/30 p-4 rounded-lg">
                        <div className="text-2xl font-bold text-purple-700 dark:text-purple-300">
                            3
                        </div>
                        <div className="text-sm text-purple-600 dark:text-purple-400">
                            ¡Listo!
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap gap-3">
                    <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition">
                        Botón Azul
                    </button>
                    <button className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition">
                        Botón Verde
                    </button>
                    <button className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-medium transition">
                        Botón Morado
                    </button>
                </div>
            </div>

            <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-6 text-white">
                <h2 className="text-xl font-semibold mb-2">Modo Oscuro</h2>
                <p className="text-white/90">
                    Tailwind tiene soporte nativo para modo oscuro. Prueba el
                    interruptor en la parte superior!
                </p>
            </div>
        </div>
    );
};

const routes = [
    {
        path: "/test-custom-layout",
        layout: CustomLayout,
        component: TestComponent,
    },
    ...routesHRM,
    ...routesACCOUNTING,
    ...routesLOGISTICS,
    ...routesBUYS,
    ...routesDISPATCHES,
    {
        path: "*",
        layout: LayoutsError,
        component: ModulesError,
    },
];
export default routes;
